import {getInitials} from 'platform/components';
import {getSize} from 'platform/foundation';
import {css, useTheme} from 'styled-components';

import {suffixTestId, TestIdProps} from 'shared/web';

interface KanbanUserAvatarProps extends TestIdProps {
  name: string;
  color: string;
}

const AVATAR_SIZE = 7; // matches platform Avatar size="small"

/**
 * Local avatar chip for kanban watched users. Platform Avatar accepts only theme color
 * paths, while kanban user colors are raw #RRGGBB values (Google Calendar palette) — render
 * the colored circle here instead of widening the platform Avatar API. Mirrors
 * big-calendar's UserColorAvatar.
 */
export function KanbanUserAvatar(props: KanbanUserAvatarProps) {
  const theme = useTheme();

  return (
    <div
      data-testid={suffixTestId('avatar', props)}
      // eslint-disable-next-line eag/no-css-property -- Muted pre-existing violation
      css={css`
        width: ${getSize(AVATAR_SIZE)};
        height: ${getSize(AVATAR_SIZE)};
        flex-shrink: 0;
        border-radius: ${theme.radii.circular};
        background-color: ${props.color};
        color: ${theme.colors.general.white};
        font-family: ${theme.fonts.body};
        font-size: ${theme.fontSizes.text.xSmall};
        font-weight: ${theme.fontWeights.medium};
        display: flex;
        align-items: center;
        justify-content: center;
        white-space: nowrap;
        line-height: 1;
      `}
    >
      {getInitials(props.name)}
    </div>
  );
}
